import React, { Fragment } from "react"
import { GAME_DESCRIPTION } from "./CONTENT"

interface GameDescriptionProps {
  minBet: number
  maxBet: number
  currency: string
}

const MAX_WIN = 8

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function GameDescription({
  minBet,
  maxBet,
  currency,
}: GameDescriptionProps): any {
  return (
    <Fragment>
      <h3>{GAME_DESCRIPTION.title}</h3>
      {GAME_DESCRIPTION.description.map((desc, id) => (
        <p key={id}>{desc}</p>
      ))}
      <br />

      <p>The max win is {`${currency} ${maxBet * MAX_WIN}`} of your bet</p>
      <p>
        Maximum Bet: {`${currency} ${maxBet}`} Minimum Bet:{" "}
        {`${currency} ${minBet}`}
      </p>
    </Fragment>
  )
}
